export const LOAD_REGIONS = 'LOAD_REGIONS'
export const LOADING_REGIONS = 'LOADING_REGIONS'
export const LOAD_REGIONS_SUCCEEDED = 'LOAD_REGIONS_SUCCEEDED'
export const LOAD_REGIONS_FAILED = 'LOAD_REGIONS_FAILED'


export function loadRegions() {
    return { type: LOAD_REGIONS }
}
